import { render, staticRenderFns } from "./ASRTranscript.vue?vue&type=template&id=04252a7f&scoped=true&"
import script from "./ASRTranscript.vue?vue&type=script&lang=js&"
export * from "./ASRTranscript.vue?vue&type=script&lang=js&"
import style0 from "./ASRTranscript.vue?vue&type=style&index=0&id=04252a7f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04252a7f",
  null
  
)

export default component.exports